import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.otp.issuance');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-otp-issuance',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.otp.issuance/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageOtpIssuanceComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public qrCodeImage: string | null = null;
    public otp = '';
    public ready = false;
    public verified = false;
    public completed = false;
    public busy = false;

    private async request(action: string, params: any = {}) {
        try { return await wiz.call(action, params, { timeout: 135000 }); }
        catch (error) { return { code: 503, data: { message: '처리 결과를 확인하지 못했습니다. 다시 시도해주세요.' } }; }
    }

    private applyState(data: any) {
        if (typeof data?.ready === 'boolean') this.ready = data.ready;
        if (typeof data?.verified === 'boolean') this.verified = data.verified;
        if (typeof data?.completed === 'boolean') this.completed = data.completed;
        if (data?.qr_code_image) this.qrCodeImage = data.qr_code_image;
        if (this.completed) this.qrCodeImage = null;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, '/');
        await this.perform('get_otp_context');
    }

    private async perform(action: string, params: any = {}) {
        if (this.busy) return;
        this.busy = true;
        this.service.loading.show();
        try {
            const response = await this.request(action, params);
            this.applyState(response.data);
            if (action === 'complete_otp') this.otp = '';
            if (response.code !== 200) {
                if (response.code >= 500 && action !== 'get_otp_context') {
                    const state = await this.request('get_otp_context');
                    if (state.code === 200) this.applyState(state.data);
                    if (this.completed) return;
                }
                await this.service.alert.error(response.data?.message || response.data);
                if (response.code === 401 || response.code === 403) location.href = '/login';
            } else if (action === 'complete_otp' && this.completed) {
                if (response.data.notification_sent === false) await this.service.alert.error('설정은 완료되었지만 안내 메일을 보내지 못했습니다. 관리자에게 문의해주세요.');
                await this.service.alert.success('OTP 설정이 완료되었습니다. 비밀번호와 OTP로 다시 로그인해주세요.');
            }
        } finally {
            this.busy = false;
            this.service.loading.hide();
            await this.service.render();
        }
    }

    public async issueOtp() { await this.perform('issue_otp'); }

    public async completeOtp() {
        if (this.busy || !this.ready) return;
        if (!this.verified && !/^[0-9]{6}$/.test(this.otp)) {
            await this.service.alert.error('앱에 표시된 OTP 인증번호 6자리를 입력해주세요.');
            return;
        }
        await this.perform('complete_otp', this.verified ? {} : { otp: this.otp });
    }

    public async logout() {
        if (this.busy) return;
        this.busy = true;
        try {
            const response = await this.request('logout');
            if (response.code === 200) location.href = '/login';
            else await this.service.alert.error(response.data?.message || response.data);
        } finally { this.busy = false; }
    }
}

export default PageOtpIssuanceComponent;